var productCardMarkup = `

 {{#products}}
	<div class="product-item" id="wishlist-item-{{ epi }}">
      <div class="product-item__link">
        <a class="grid-view-item__link grid-view-item__image-container full-width-link" href="{{du}}">
          <span class="visually-hidden hide">{{dt}}</span>
        </a>

        <a class="product-item__image product-card__image-wrapper js" href="{{du}}" data-product-id="{{ empi }}">
          <img  class="grid-view-item__image product-item__img product-item__img--always-visible picture__img--cover active lazyautosizes" src="{{iu}}" />
          <div class="quick-add">

          </div>

        </a>

        <div class="product-item__info">
          <header class="product-item--header">
            <h2 class="product-item--title"><a href="{{ du }}">{{title}}</a></h2>

            <div class="price product-item--price" data-price="">
              <span class="price-item price-item--sale" data-sale-price="">
                {{cu}}{{pr}}
              </span>
            </div>

          </header>

          <a class="cta-link" href="{{du}}">See Details</a>

          <div class="color-labels" id="wishlist-colors-{{ epi }}">


          </div>





        <div class="sizes-and-btn">
          <div class="options-wrapper">


          </div>



          </div>
        </div>

    </div>
    </div>
  {{/products}}

`;

var minicookie = Cookies.get("showMiniCart");

// console.log("showMiniCart cookie: " + minicookie);
if (minicookie == 'true') {
  // console.log("show mini cart!");
  Cookies.set("showMiniCart", 'false');
  $(".device-nav-cart").trigger("click");
}

$(".hero .block-title").text("Favorites.");
$(".wishlist").removeClass("init");


 // https://argentwork.com/apps/swymWishlist/shared/index.php?swaction=shared&hkey=X76MYs0nsv2t0E0cohYzTA&swiu=%26%23x2F%3B%26%23x2F%3Bcdn.shopify.com%26%23x2F%3Bs%26%23x2F%3Bfiles%26%23x2F%3B1%26%23x2F%3B1225%26%23x2F%3B0040%26%23x2F%3Bproducts%26%23x2F%3B10003_LOOK03_FULL_FR_620x620.jpg%3Fv%26%23x3D%3B1585510402&utm_source=swym-Wishlist&utm_medium=shared-wishlist&utm_term=X76MYs0nsv2t0E0cohYzTA&utm_campaign=X76MYs0nsv2t0E0cohYzTA
// Fetch Products based on who shared.
function fetchSharedWishlistProducts(){
  //   Get the Hkey
  var userHkey = SwymUtils.getParameterByName("hkey");
  if(userHkey.trim() !== ""){
    _swat.sharedWlApi.fetch({
      params: {hkey: userHkey},
      scb: function(res) {
        console.log(res);
        renderWishlistUI(res.queryres);
      },
      fcb: function() {
        SwymUtils.error("Error fetching shared wishlisted Products", arguments);
        errorCallback(null);
      }
    });
  }

}

// Render the Products in the User Interface.
function renderWishlistUI(products){
  //fetch the container.
  var wishlistContentsContainer = document.getElementById("wishlist-items-container");

  //   format products if required
  var formattedWishlistedProducts = products.map(function(p){
    p = SwymUtils.formatProductPrice(p);    // formats product price and adds currency to product Object
    return p;
  });

  //render the page.
  var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {products: formattedWishlistedProducts});
  wishlistContentsContainer.innerHTML = productCardsMarkup;


};

function errorCallbackFn(){
  //   your error callback.
  console.log("error, rendering shared wishlisted products");
}

if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(fetchSharedWishlistProducts);



function changeAddToCartClick($t){
  // console.log($t.attr("class"));
  if (!$t.hasClass("quick-add--out-of-stock")) {
    var productId = $t.attr("data-product-id");
    var variantId = $t.attr("data-variant-id");
    var url = $t.attr("data-url");
    $t.addClass("selected").siblings().removeClass("selected");
    // console.log("pro: " + productId);
    // console.log("var: " + variantId);
    var parent  = $t.parents(".product-item").first();
    if (parent) {
      var add = parent.find(".add-to-cart");
      // console.log(add.length);
      if (add.length) {
        add.attr("data-product-id", productId).attr("data-variant-id", variantId).attr("data-url", url);
        if ($t.is(":visible")) {
          console.log("trigger click???");
          add.trigger("click");
        }
      }

    }
  }
}

function changeAddToCartClickFromMobile($t){
  if (!$t.hasClass("quick-add--out-of-stock")) {
    var parent  = $t.parents(".product-item").first();
    var p = $t.parents('.option--size').first();
    var t = p.find(".selected-size");
    var n = p.find(".option-name-click");
    var size = $t.attr("data-size");
    var product_id = p.attr("data-product-id");
    // console.log("product_id: " + product_id)
    t.html(size);

    $t.addClass("active").siblings(".active").removeClass("active");

    if (t.hasClass("active")) {
      t.trigger("click");
    }
    if (n.length && n.hasClass("active")) {
      n.trigger("click");
    }

    if (parent) {
      var size = parent.find(".quick-add__back[data-product-id="+product_id+"] .quick-add__button[data-size='"+size+"']");
      if (size) {
        size.trigger("click");
      }

    }
  }
}

function onAddToCartClick(e){
  e.preventDefault();
  var productId = e.target.getAttribute("data-product-id");
  var variantId = e.target.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-url");
  e.target.innerHTML = "Adding..";
  window._swat.replayAddToCart(
   {empi: productId, du: du},
   variantId,
   function() {
     // e.target.innerHTML = "<span>Added... </span>";
     // e.target.classList.add("added");
     Cookies.set("showMiniCart", 'true');
     // console.log("Setting? showMiniCart cookie: " + Cookies.set("showMiniCart"));

     /*
     var mini = document.getElementById("quick-cart");
     if (mini) {
       mini.classList.add("active");
       setTimeout(function() {
         mini.classList.remove("active");
       }, 5000)
     } */



     window.location.reload();
     // console.log("Added to cart.");
   },
   function(e) {
     console.log(e);
   }
  );
}


function attachClickListeners(){
  var addToCartButtons = document.getElementsByClassName("add-to-cart");

  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  }

  $(".swym-add-to-wishlist-view-product").click(function(e) {
    e.preventDefault();
    var product_id = $(this).attr("data-product-id");
    var variant_id = $(this).attr("data-variant-id");
    _swat.removeFromWishList({ empi: product_id, epi: variant_id }, function() {
      window.location.reload();
    })
  })

  // var wishlistShare = document.getElementById("share-wishlist-btn");
  // wishlistShare.addEventListener('click', shareWishlist, false);
}

var getClosest = function (elem, selector) {

	// Element.matches() polyfill
	if (!Element.prototype.matches) {
	    Element.prototype.matches =
	        Element.prototype.matchesSelector ||
	        Element.prototype.mozMatchesSelector ||
	        Element.prototype.msMatchesSelector ||
	        Element.prototype.oMatchesSelector ||
	        Element.prototype.webkitMatchesSelector ||
	        function(s) {
	            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
	                i = matches.length;
	            while (--i >= 0 && matches.item(i) !== this) {}
	            return i > -1;
	        };
	}

	// Get the closest matching element
	for ( ; elem && elem !== document; elem = elem.parentNode ) {
		if ( elem.matches( selector ) ) return elem;
	}
	return null;

};

function string_to_slug (str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to   = "aaaaeeeeiiiioooouuuunc------";
    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}

function getSwatchStyle(color) {
  var slug = string_to_slug(color);
  var swatch = $("#wishlist-swatch-color-" + slug);
  if (swatch.length) {
    var swatchImg = swatch.attr("data-swatch");
    var style = "background-image: url("+swatchImg+")";
  } else {
    var style = '';
  }
  return style;
}

function makeSwatch(id, style, color, active) {
  var checked = ''
  if (active == true) {
    active = 'product-item__swatch--active';
    checked = 'checked';
  } else {
    active = '';
  }

  var html = ` <div class="color-label">
              <label for="swatch-`+id+`"
                class="product-item__swatch `+active+`" data-product-id="`+id+`">
                <input
                  type="radio"
                  id="swatch-`+id+`"
                  class="product-item__swatch-selector"
                  name="variant"
                  value="`+id+`"
                  `+checked+` />
                <div
                  class="color" style="`+style+`"></div>

              </label>
              <span class="color-name type-e"  id="wishlist-color-`+id+`">`+color+`</span>
            </div>`;
  return html;
}

function makeSizes(inventory, id, vid, label, url) {
  var invent_class = '';
  if (inventory < 1) {
    invent_class = " quick-add--out-of-stock"
  }
  var sizes = '<div class="quick-add__button'+invent_class+'" data-product-id="'+id+'" data-variant-id="'+vid+'" data-url="'+url+'" data-size="'+label+'">' + label + '</div>';
  var mobilesizes = '<label class="option-value" data-size="'+label+'"><input class="option__input" type="radio" name="size" value="'+label+'"><div class="option-value__label" data-size="'+label+'">'+label+'</div></label>';

  return { sizes: sizes, mobilesizes: mobilesizes }
}

function populateMobileSizes(mobilesizes, id, active) {
  if (active == true) {
    active = ' active';
  } else {
    active = '';
  }
  var html = `<div
    class="option--size`+active+`"
    data-option-index="1"
    data-option-is-swatch="false"
    data-option-is-master="false"
    data-product-id="`+id+`">

    <div class="option__values-wrapper type-e">
       <div class="selected-size">Select a Size</div>
       <div class="option__values">`+mobilesizes+`</div>
   </div>
  </div>`;

  return html;
}

function populateSizes(sizes, id, active) {
  if (active == true) {
    active = ' active';
  } else {
    active = '';
  }
  var html = `<div class="quick-add__back type-e`+active+`" id="wishlist-item-`+id+`-sizes" data-product-id="`+id+`">`+sizes+`</div>`;
  return html;
}
